import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["authType", "name", "onContent", "onError", "onNoContent", "onVideoEngagement", "onVideoFinish", "onVideoPlay", "onVideoProgress", "onWatermarkClick", "variant"];
import PropTypes from 'prop-types';
import { Frame } from './Frame';
import { useSyncStaticState } from '../hooks/staticWidgetHooks';
import { useSyncIFrameHeight } from '../hooks/syncIFrameHeightHooks';
import { View } from 'foundations-components/components/View';
import ACSkeletonBox from 'academy-common-lib/components/loading/ACSkeletonBox';
import { useState } from 'react';
import * as Hublets from 'hubspot-url-utils/hublets-next';
import { renderContexts } from '../constants';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const propTypes = {
  Description: PropTypes.func,
  Link: PropTypes.func,
  Title: PropTypes.func,
  authType: PropTypes.oneOf(['app', 'public']),
  autoPlay: PropTypes.bool,
  contentId: PropTypes.number,
  enablePictureInPicture: PropTypes.bool,
  hublet: PropTypes.oneOf(Object.keys(Hublets)),
  language: PropTypes.string,
  lessonId: PropTypes.number,
  linkTextProps: PropTypes.object,
  mutedByDefault: PropTypes.bool,
  name: PropTypes.string.isRequired,
  onContent: PropTypes.func,
  onError: PropTypes.func,
  onNoContent: PropTypes.func,
  onVideoEngagement: PropTypes.func,
  onVideoFinish: PropTypes.func,
  onVideoPlay: PropTypes.func,
  onVideoProgress: PropTypes.func,
  onWatermarkClick: PropTypes.func,
  renderContext: PropTypes.oneOf(renderContexts),
  sectionEndTime: PropTypes.string,
  shortId: PropTypes.number,
  startTime: PropTypes.string,
  variant: PropTypes.oneOf(['default', 'video']),
  videoWrapperProps: PropTypes.object
};
export const StaticContentWidget = _ref => {
  let {
      authType,
      name,
      onContent,
      onError,
      onNoContent,
      onVideoEngagement,
      onVideoFinish,
      onVideoPlay,
      onVideoProgress,
      onWatermarkClick,
      variant = 'default'
    } = _ref,
    rest$ = _objectWithoutPropertiesLoose(_ref, _excluded);
  const rest = Object.assign({
    variant
  }, rest$);
  const [isLoading, setIsLoading] = useState(true);
  const handleOnContent = content => {
    setIsLoading(false);
    if (onContent) onContent(content);
  };
  const handleOnError = () => {
    setIsLoading(false);
    if (onError) onError();
  };
  const handleOnNoContent = () => {
    setIsLoading(false);
    if (onNoContent) onNoContent();
  };
  const {
    registerIFrame: registerSyncHeight,
    height
  } = useSyncIFrameHeight();
  const {
    registerIFrame: registerSyncDynamic
  } = useSyncStaticState({
    newState: Object.assign({
      authType
    }, rest),
    onContent: handleOnContent,
    onError: handleOnError,
    onNoContent: handleOnNoContent,
    onVideoEngagement,
    onVideoFinish,
    onVideoPlay,
    onVideoProgress,
    onWatermarkClick
  });

  // After loading, the iframe has height 0 for a fraction of a second
  // We need to wait to prevent flickering
  const iframeReady = !isLoading && height !== 0;
  return /*#__PURE__*/_jsxs(View, {
    position: "relative",
    children: [!iframeReady && /*#__PURE__*/_jsx(View, {
      "data-testid": "static-content-loading",
      inlineSize: "100%",
      marginBlockEnd: "200",
      children: /*#__PURE__*/_jsx(ACSkeletonBox, {
        animated: true,
        style: {
          width: '100%',
          paddingBottom: variant === 'default' ? 10 : 0
        },
        children: /*#__PURE__*/_jsx("div", {
          style: {
            aspectRatio: '16 / 9'
          }
        })
      })
    }), /*#__PURE__*/_jsx(Frame, {
      height: height,
      name: name,
      refHandlers: [registerSyncHeight, registerSyncDynamic]
      // We need to hide the iframe while loading but also keep it in the DOM for the iframe resizer to work
      ,
      style: iframeReady ? {} : {
        position: 'absolute',
        height: 0
      },
      targetWidget: authType === 'public' ? 'staticPublic' : 'static'
    })]
  });
};
StaticContentWidget.propTypes = propTypes;